const BASE_URL = process.env.REACT_APP_API_URL ? (process.env.REACT_APP_API_URL + '/api/v1') : '/api/v1';


function getToken() {
  return localStorage.getItem("driver_token");
}

function authHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getToken()}`,
  };
}

export const driverAuthAPI = {
  login: (email, password) =>
    fetch(`${BASE_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    }).then((r) => r.json()),

  sendOtp: (phone) =>
    fetch(`${BASE_URL}/phone_auth/send_otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone }),
    }).then((r) => r.json()),

  verifyOtp: (phone, otp) =>
    fetch(`${BASE_URL}/phone_auth/verify_otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone, otp }),
    }).then((r) => r.json()),

  resendOtp: (phone) =>
    fetch(`${BASE_URL}/phone_auth/resend_otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone }),
    }).then((r) => r.json()),
};

export const driverTasksAPI = {
  // GET /api/v1/drivers/tasks
  getTasks: () =>
    fetch(`${BASE_URL}/drivers/tasks`, {
      headers: authHeaders(),
    }).then((r) => r.json()),

  // PATCH /api/v1/drivers/pickups/:id
  updatePickup: (id, status) =>
    fetch(`${BASE_URL}/drivers/pickups/${id}`, {
      method: "PATCH",
      headers: authHeaders(),
      body: JSON.stringify({ status }),
    }).then((r) => r.json()),

  // PATCH /api/v1/drivers/deliveries/:id
  updateDelivery: (id, status) =>
    fetch(`${BASE_URL}/drivers/deliveries/${id}`, {
      method: "PATCH",
      headers: authHeaders(),
      body: JSON.stringify({ status }),
    }).then((r) => r.json()),
};